import templateUrl from './admins-by-category-bar.html';

export default {
  templateUrl,
  controller: class AdministrationsByCategoryBarComponent {
    constructor($scope, LoadingService, AdminsByCategoryBarService, ToastService) {
      'ngInject';

      Object.assign(this, {
        $scope,
        LoadingService,
        AdminsByCategoryBarService,
        ToastService
      });

      // window.Highcharts.theme = {
      //   colors: ['#f45b5b', '#8085e9', '#8d4654', '#7798BF', '#aaeeee',
      //     '#ff0066', '#eeaaee', '#55BF3B', '#DF5353', '#7798BF', '#aaeeee'],
      //   chart: {
      //     backgroundColor: null,
      //     style: {
      //       fontFamily: 'Signika, serif'
      //     }
      //   },
      //   title: {
      //     style: {
      //       color: 'black',
      //       fontSize: '16px',
      //       fontWeight: 'bold'
      //     }
      //   },
      //   subtitle: {
      //     style: {
      //       color: 'black'
      //     }
      //   },
      //   tooltip: {
      //     borderWidth: 0
      //   },
      //   legend: {
      //     itemStyle: {
      //       fontWeight: 'bold',
      //       fontSize: '13px'
      //     }
      //   },
      //   xAxis: {
      //     labels: {
      //       style: {
      //         color: '#6e6e70'
      //       }
      //     }
      //   },
      //   yAxis: {
      //     labels: {
      //       style: {
      //         color: '#6e6e70'
      //       }
      //     }
      //   },
      //   plotOptions: {
      //     series: {
      //       shadow: true
      //     },
      //     candlestick: {
      //       lineColor: '#404048'
      //     },
      //     map: {
      //       shadow: false
      //     }
      //   },

      //   // Highstock specific
      //   navigator: {
      //     xAxis: {
      //       gridLineColor: '#D0D0D8'
      //     }
      //   },
      //   rangeSelector: {
      //     buttonTheme: {
      //       fill: 'white',
      //       stroke: '#C0C0C8',
      //       'stroke-width': 1,
      //       states: {
      //         select: {
      //           fill: '#D0D0D8'
      //         }
      //       }
      //     }
      //   },
      //   scrollbar: {
      //     trackBorderColor: '#C0C0C8'
      //   },

      //   // General
      //   background2: '#E0E0E8'
      // };
      // window.Highcharts.setOptions(window.Highcharts.theme);
    }

    getChartConfig() {
      return {
        chart: {
          type: 'column',
          inverted: true,
          marginLeft: 225,
          zoomType: 'xy'
        },
        title: {
          text: 'Administrations by Product Category'
        },
        subtitle: {
          text: 'NASC Adverse Event Reporting System'
        },
        xAxis: [{
          type: 'category',
          title: {
            style: {
              fontSize: '14px'
            }
          },
          labels: {
            style: {
              fontSize: '14px'
            }
          }
        }],
        yAxis: [{
          title: {
            text: 'Administrations (mils)',
            style: {
              color: window.Highcharts.getOptions().colors[1],
              fontSize: '14px'
            }
          },
          labels: {
            format: '{value}',
            style: {
              color: window.Highcharts.getOptions().colors[1],
              fontSize: '14px'
            }
          }
        }],
        legend: {
          align: 'center',
          itemStyle: {
            fontSize: '14px'
          }
        },
        plotOptions: {
          pie: {
            size: 500,
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: true,
              format: '{point.name}: {point.percentage:.1f}%',
              style: {
                fontSize: '14px'
              }
            },
            showInLegend: true
          },
          column: {
            stacking: 'normal',
            align: 'top',
            pointPadding: 0,
            groupPadding: 0.1,
            borderWidth: 0,
            dataLabels: {
              enabled: true,
              format: '{point.y:,.2f}'
            }
          }
        },
        tooltip: {
          headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
          pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
            '<td style="padding:0"><b>{point.y:,.2f} mil</b></td></tr>',
          footerFormat: '</table>',
          split: true,
          useHTML: true
        }
      };
    }

    $onInit() {
      this.chartConfig = this.getChartConfig();
    }

    generateReport({ params }) {
      this.LoadingService.start();
      this.AdminsByCategoryBarService.getReport(params)
        .then(({ series, drilldown }) => {
          this.chartConfig = undefined;
          this.$scope.$apply();
          this.chartConfig = this.getChartConfig();
          this.chartConfig.series = series;
          this.chartConfig.drilldown = drilldown;
        }).catch(error => this.ToastService.showError(error))
        .finally(() => {
          this.LoadingService.stop();
          this.$scope.$apply();
        });
    }
  }
};



// WEBPACK FOOTER //
// ./components/app/reports/admins-by-category-bar/admins-by-category-bar.component.js